import { render, staticRenderFns } from "./tabulation.vue?vue&type=template&id=240e002f&scoped=true&"
import script from "./tabulation.vue?vue&type=script&lang=js&"
export * from "./tabulation.vue?vue&type=script&lang=js&"
import style0 from "./tabulation.vue?vue&type=style&index=0&id=240e002f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240e002f",
  null
  
)

export default component.exports